import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import Button from '@plasma/ui.general.button';
import Select from '@plasma/ui.input.select';

import { ConsumableLifetimeCycleTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ConsumableLifetimeCycleTheme>;
const css = baseCss as ThemedCssFunction<ConsumableLifetimeCycleTheme>;

export const ConsumableLifetimeCycle = styled.div`
  width: 100%;
  height: 100%;
`;

export const NormalPlasmaButton = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.mode.consumableLifetimeCycle.normalButtonBGColor} !important;
    border: ${theme.mode.consumableLifetimeCycle.normalButtonBorderColor} !important;
  `}
`;

export const NormalPlasmaSelect = styled(Select)`
  .ant-select-clear {
    margin-right: 1vw;
  }
`;
